import { OrganizationClassSection } from './organization-detail';

export class Organization {
  ID: number;
  Description: string;
  TypeCode: string;
  TypeDescription: string;
  ExternalID?: string;
  LoginCode: string;
  ParentOrganizationID?: number;
  ParentOrganizationDescription?: string;
  ClassSection?: OrganizationClassSection;

  static getType(org: Organization) {
    // return org.TypeDescription === 'Administrative' ? 'District' : org.TypeDescription === 'Class Section' ? 'Class' : org.TypeDescription;
    return org.TypeCode === 'CS' ? 'Class' : 'Organization';
  }

  static getLink(org: Organization): string {
    return org.TypeCode === 'CS' ? `/classes/${org.ID}/class/${org.ClassSection && org.ClassSection.ClassID || 'latest'}` : `/organizations/${org.ID}`;
  }

  static getLinkQueryParams(org: Organization, tab: string): any {
    return tab && org.TypeCode === 'CS' && { 'pt': tab };
  }
}
